export const profileOptionsADMIN = [
  {
    key: 'users',
    matIcon: 'manage_accounts',
    name: 'USER_MENU.USERS_SETTINGS',
  },
  {
    key: 'logs',
    matIcon: 'history',
    name: 'USER_MENU.LOG_ACCESS',
  },
  {
    key: 'portal',
    matIcon: 'open_in_new',
    name: 'USER_MENU.SWITCH_PORTAL',
  },
  {
    key: 'firm',
    matIcon: 'swap_horiz',
    name: 'USER_MENU.SWITCH_FIRM',
  },
];

export const userMenuEN = {
  LOGOUT: 'Log out',
  USERS_SETTINGS: 'Users settings',
  SWITCH_PORTAL: 'Portal access',
  LOG_ACCESS: 'Log access',
  SWITCH_FIRM: 'Change Firm',
  ROLE_ADMIN: 'Administrator',
  ROLE_SIGN: 'Signer',
  ROLE_EDIT: 'Editor',
  ROLE_READ: 'Read-only',
  ROLE_CLIENT: 'Client',
  ROLE_IT: 'IT',
  ROLE_LOGS: 'Audit',
};

export const userMenuES = {
  LOGOUT: 'Salir',
  USERS_SETTINGS: 'Configuración de usuarios',
  SWITCH_PORTAL: 'Acceder al Portal',
  LOG_ACCESS: 'Acceso a Logs',
  SWITCH_FIRM: 'Cambiar de Firma',
  ROLE_ADMIN: 'Administrador',
  ROLE_SIGN: 'Firmante',
  ROLE_EDIT: 'Editor',
  ROLE_READ: 'Lectura',
  ROLE_CLIENT: 'Cliente',
  ROLE_IT: 'IT',
  ROLE_LOGS: 'Auditoría',
};
